import { Link } from 'react-router-dom';

export default function LeistungenHero() {
  return (
    <section className="relative pt-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/79ee9a04452d18948938a4306536061d.jpg"
          alt="Unsere Leistungen"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0D2B4E]/90 via-[#0D2B4E]/75 to-[#0D2B4E]/40" />
      </div>

      <div className="relative container mx-auto px-4 sm:px-6 py-20 sm:py-28">
        <nav className="flex items-center gap-2 text-sm text-white/60 mb-6" aria-label="Breadcrumb">
          <Link to="/" className="hover:text-white transition-colors cursor-pointer">Startseite</Link>
          <div className="w-3 h-3 flex items-center justify-center">
            <i className="ri-arrow-right-s-line" />
          </div>
          <span className="text-white">Leistungen</span>
        </nav>

        <div className="max-w-2xl">
          <span className="inline-block text-xs font-semibold tracking-widest text-white/70 uppercase mb-4">
            Was wir für Sie tun
          </span>
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-5">
            Unsere Leistungen im Überblick
          </h1>
          <p className="text-base sm:text-lg text-white/80 leading-relaxed max-w-xl mb-8">
            Von der Bausanierung bis zur Gartengestaltung – wir bieten das komplette Spektrum an
            Bau-, Sanierungs- und GalaBau-Dienstleistungen für Privat und Gewerbe in ganz NRW.
          </p>

          <div className="flex flex-wrap gap-4">
            <Link
              to="/kontakt"
              className="inline-flex items-center gap-2 bg-white text-[#0D2B4E] px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-line" />
              </div>
              Kostenlos anfragen
            </Link>
            <a
              href="#leistungen-liste"
              className="inline-flex items-center gap-2 border border-white/40 text-white px-6 py-3 rounded-lg font-semibold hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-down-line" />
              </div>
              Alle Leistungen
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
